import { api } from '@creditsights/api-ui-web';
import { TagDto } from '../dtos/tags/tag.dto';

const tagsUri = '/common/v1/tags';

export const searchTags = async (tags: string[]): Promise<Record<string, TagDto>> => {
  const { data } = await api.post<Record<string, TagDto>>(`${tagsUri}/search`, { tags });
  return data;
};
